"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Visibility_1 = require("../../lib/constants/Visibility");
const getInitialContext = () => ({
    appointmentId: '',
    appointment: undefined,
    provider: undefined,
    selectedSlot: undefined,
    capabilities: undefined,
    query: {},
    filterBy: {
        dayOfWeek: new Set(),
        timeOfDay: new Set()
    },
    reason: null,
    visibility: {
        role: Visibility_1.CONSUMER_ROLE,
        schedulingVisibility: Visibility_1.SCHEDULING_VISIBILITY_CONSUMER,
        isVisibilityAgent: false
    },
    appointmentQuery: {},
    apptTimeMachine: undefined,
    reasonMachine: undefined,
    loadingMachine: undefined,
    keptOriginalAppointment: false,
    services: {
        getAppointment: () => Promise.resolve({}),
        getProvider: () => Promise.resolve({}),
        getRescheduleReasons: () => Promise.resolve({}),
        rescheduleAppointment: () => Promise.resolve({})
    },
    customerCode: ''
});
exports.default = getInitialContext;
//# sourceMappingURL=getInitialContext.js.map